export default __webpack_public_path__ + "static/media/checkers-6-rMAX.6637d904.jpg";